import VDMDashboardWeather from "components/app/vdmdashboard/weather/VDMDashboardWeather";
import React from "react";

type ScreenVDMDashboardWeatherType = React.PropsWithChildren<{
	match: {
		params: {
			vesselId: string;
		};
	};
}>;
const ScreenVDMDashboardWeather: React.FC<ScreenVDMDashboardWeatherType> = (
	props: ScreenVDMDashboardWeatherType
) => {
	return <VDMDashboardWeather vesselId={props.match.params.vesselId} />;
};

export default ScreenVDMDashboardWeather;